import { gql } from "apollo-boost";

export default gql`
  mutation CreateListingRecommendation(
    $listing_id: ID!
    $listing_type: ListingClass!
    $helpful: Boolean!
  ) {
    create_listing_recommendation_user_response(
      input: {
        listing_id: $listing_id
        listing_type: $listing_type
        helpful: $helpful
      }
    )
  }
`;
